module.exports = __webpack_public_path__ + "static/img/img9.c9bb7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img9.png
// module id = 5xXR
// module chunks = 0